import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsTargetProducts(companyId, regulationId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_TARGET_PRODUCTS].getRegulationsTargetProducts,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
			},
		},
	)
}
function getRegulationsTargetProductPreview(companyId, regulationId, targetProductId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_TARGET_PRODUCTS].getRegulationsTargetProductPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				targetProductId,
			},
		},
	)
}
function getRegulationsTargetProductPopup(companyId, regulationId, targetProductId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_TARGET_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_TARGET_PRODUCTS].getRegulationsTargetProductPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				targetProductId,
			},
		},
	)
}

function createRegulationsTargetProduct(companyId, regulationId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_TARGET_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_TARGET_PRODUCTS].createRegulationsTargetProduct, {
		urlParams: {
			companyId,
			regulationId,
		},
		...data,
	})
}

function getRegulationsTargetProduct(companyId, regulationId, targetProductId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_TARGET_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_TARGET_PRODUCTS].getRegulationsTargetProduct, {
		urlParams: {
			companyId,
			regulationId,
			targetProductId,
		},
	})
}

function patchRegulationsTargetProduct(companyId, regulationId, targetProductId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_TARGET_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_TARGET_PRODUCTS].patchRegulationsTargetProduct, {
		urlParams: {
			companyId,
			regulationId,
			targetProductId,
		},
		...data,
	})
}

function putRegulationsTargetProduct(companyId, regulationId, targetProductId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_TARGET_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_TARGET_PRODUCTS].putRegulationsTargetProduct, {
		urlParams: {
			companyId,
			regulationId,
			targetProductId,
		},
		...data,
	})
}

function deleteRegulationsTargetProduct(companyId, regulationId, targetProductId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_TARGET_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_TARGET_PRODUCTS].deleteRegulationsTargetProduct, {
		urlParams: {
			companyId,
			regulationId,
			targetProductId,
		},
	})
}

export default {
	getRegulationsTargetProducts,
	getRegulationsTargetProductPopup,
	getRegulationsTargetProductPreview,
	getRegulationsTargetProduct,
	patchRegulationsTargetProduct,
	putRegulationsTargetProduct,
	createRegulationsTargetProduct,
	deleteRegulationsTargetProduct,
}
